import { AssetType } from '#/graphql/types';
import { Key } from '#/types';

const mutationFields: Key<AssetType>[] = [
  'name',
  'category',
  'defaultRiskScore',
  'description',
  'criticalityLevel',
  'expectedUsefulLife',
  'defaultWarrantyPeriod',
  'manufacturerRecommendations',
  'image',
  'inUseStatus',
  'tenantId',
];

export default mutationFields;
